import { useTranslation } from 'react-i18next';

import { useDeleteGoogleAdsTemplatesMutation } from '@adflow/frontend/feat-google-ads';
import { useDeleteGoogleMyBusinessTemplatesMutation } from '@adflow/frontend/feat-google-my-business';
import { useDataTableMeta } from '@adflow/frontend/ui-data-table';
import { ModalDialog } from '@adflow/frontend/ui-modal';
import type { NavAction } from '@adflow/frontend/util-router';
import { useDispatchNavAction } from '@adflow/frontend/util-router';

import { useDeleteFacebookTemplatesMutation } from './facebook-template-queries';

interface DeleteConfirmationProps {
	show: boolean;
	setShow: (show: boolean) => void;
	goTo: NavAction;
	type?: 'FACEBOOK' | 'GOOGLE' | 'GMB';
}

export function DeleteConfirmation({
	show,
	setShow,
	goTo,
	type,
}: DeleteConfirmationProps) {
	const { t } = useTranslation(['common', 'facebook']);
	const { selected, setSelected } = useDataTableMeta();

	const navigate = useDispatchNavAction();

	const deleteMutation =
		type === 'FACEBOOK'
			? useDeleteFacebookTemplatesMutation
			: type === 'GMB'
				? useDeleteGoogleMyBusinessTemplatesMutation
				: useDeleteGoogleAdsTemplatesMutation;

	const { mutateAsync: deleteTemplates } = deleteMutation();

	return (
		<ModalDialog
			show={show}
			onCancel={() => setShow(false)}
			onConfirm={async () => {
				if (selected.length < 0) return;
				await deleteTemplates(selected.map(Number))
					.then(() => {
						navigate(goTo);
					})
					.catch(() => {
						setShow(false);
					});
				setSelected([]);
				setShow(false);
			}}
			headerContent={t('facebook:deleteFacebookTemplateSection.title')}
			bodyContent={t('facebook:deleteFacebookTemplateSections.description', {
				count: selected.length,
			})}
			confirmButtonContent={t('facebook:deleteFacebookTemplateSection.confirm')}
			type="archive"
		/>
	);
}
